import "./configs/i18n"
import "./index.css"

import App from "./App"
import { AuthProvider } from "./contexts/Auth/AuthContext"
import { DocumentProvider } from "./contexts/Document/DocumentContext"
import React from "react"
import ReactDOM from "react-dom/client"
import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <AuthProvider>
    <DocumentProvider>
      <App />
    </DocumentProvider>
  </AuthProvider>
)

reportWebVitals()
